<!-- <div class="w-full">

        <div class="mb-4 flex items-center gap-3 sm:mb-6">
        <button (click)="cancel()"
            class="flex h-9 w-9 items-center justify-center rounded-xl border border-gray-200 text-gray-500 transition hover:bg-gray-50">
            <i class="fas fa-arrow-right text-sm"></i>
        </button>
        <h2 class="text-base text-gray-900 sm:text-lg">{{ 'developerDashboard.createUnit.title' | translate }}</h2>
    </div>

        <div class="mb-6 flex gap-1 rounded-2xl bg-gray-100 p-1">
        <button *ngFor="let s of steps" (click)="setStep(s.key)"
            class="flex flex-1 items-center justify-center gap-2 rounded-xl py-2.5 text-sm transition"
            [ngClass]="step === s.key ? 'bg-white shadow-sm text-gray-900' : 'text-gray-500 hover:text-gray-700'">
            <i class="fas text-xs" [ngClass]="s.icon"></i>
            <span>{{ s.label | translate }}</span>
        </button>
    </div>

        <div *ngIf="saveSuccess" class="mb-4 rounded-xl bg-green-50 px-4 py-3 text-sm text-green-700">
        <i class="fas fa-check-circle me-2"></i>{{ saveSuccess }}
    </div>
    <div *ngIf="saveError" class="mb-4 rounded-xl bg-red-50 px-4 py-3 text-sm text-red-600">
        <i class="fas fa-exclamation-circle me-2"></i>{{ saveError }}
    </div>

        <div *ngIf="step === 'common'" class="space-y-5">

             <div>
            <label class="mb-1.5 block text-sm text-gray-700">{{ 'developerDashboard.createUnit.project' | translate
                }}</label>
            <div *ngIf="loadingProjects" class="flex items-center gap-2 text-sm text-gray-400">
                <i class="fas fa-spinner fa-spin"></i> {{ 'developerDashboard.createUnit.loadingProjects' | translate }}
            </div>
            <select *ngIf="!loadingProjects" [(ngModel)]="projectId"
                class="w-full rounded-xl border border-gray-300 px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#de5806]">
                <option value="" disabled>{{ 'developerDashboard.createUnit.selectProject' | translate }}</option>
                <option *ngFor="let p of projects" [value]="p._id">{{ p.name }}</option>
            </select>
        </div>

            <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
            <div>
                <label class="mb-1.5 block text-sm text-gray-700">{{ 'developerDashboard.createUnit.titleAr' | translate
                    }}</label>
                <input type="text" dir="rtl" [(ngModel)]="title_ar"
                    class="w-full rounded-xl border border-gray-300 px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#de5806]" />
            </div>
            <div>
                <label class="mb-1.5 block text-sm text-gray-700">{{ 'developerDashboard.createUnit.titleEn' | translate
                    }}</label>
                <input type="text" [(ngModel)]="title_en"
                    class="w-full rounded-xl border border-gray-300 px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#de5806]" />
            </div>
            <div class="md:col-span-2">
                <label class="mb-1.5 block text-sm text-gray-700">{{ 'developerDashboard.createUnit.descriptionAr' |
                    translate }}</label>
                <textarea rows="3" dir="rtl" [(ngModel)]="description_ar"
                    class="w-full resize-none rounded-xl border border-gray-300 px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#de5806]"></textarea>
            </div>
            <div class="md:col-span-2">
                <label class="mb-1.5 block text-sm text-gray-700">{{ 'developerDashboard.createUnit.descriptionEn' |
                    translate }}</label>
                <textarea rows="3" [(ngModel)]="description_en"
                    class="w-full resize-none rounded-xl border border-gray-300 px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#de5806]"></textarea>
            </div>
        </div>

            <div class="grid grid-cols-2 gap-4 md:grid-cols-4">
            <div>
                <label class="mb-1.5 block text-sm text-gray-700">{{ 'developerDashboard.createUnit.unitNumber' |
                    translate }}</label>
                <input type="text" [(ngModel)]="unitNumber"
                    class="w-full rounded-xl border border-gray-300 px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#de5806]" />
            </div>
            <div>
                <label class="mb-1.5 block text-sm text-gray-700">{{ 'developerDashboard.createUnit.unitType' |
                    translate }}</label>
                <select [(ngModel)]="unitType_en"
                    class="w-full rounded-xl border border-gray-300 px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#de5806]">
                    <option *ngFor="let t of unitTypes" [value]="t.key">{{ t.label_ar }}</option>
                </select>
            </div>
            <div>
                <label class="mb-1.5 block text-sm text-gray-700">{{ 'developerDashboard.createUnit.purpose' | translate
                    }}</label>
                <select [(ngModel)]="purpose"
                    class="w-full rounded-xl border border-gray-300 px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#de5806]">
                    <option value="rent">{{ 'developerDashboard.createUnit.purposeRent' | translate }}</option>
                    <option value="sale">{{ 'developerDashboard.createUnit.purposeSale' | translate }}</option>
                    <option value="sale_and_rent">{{ 'developerDashboard.createUnit.purposeSaleAndRent' | translate }}
                    </option>
                </select>
            </div>
            <div>
                <label class="mb-1.5 block text-sm text-gray-700">{{ 'developerDashboard.createUnit.buildYear' |
                    translate }}</label>
                <input type="number" [(ngModel)]="buildYear"
                    class="w-full rounded-xl border border-gray-300 px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#de5806]" />
            </div>
            <div>
                <label class="mb-1.5 block text-sm text-gray-700">{{ 'developerDashboard.createUnit.area' | translate
                    }}</label>
                <input type="number" min="1" [(ngModel)]="unitArea"
                    class="w-full rounded-xl border border-gray-300 px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#de5806]" />
            </div>
            <div>
                <label class="mb-1.5 block text-sm text-gray-700">{{ 'developerDashboard.createUnit.bedrooms' |
                    translate }}</label>
                <select [(ngModel)]="bedrooms"
                    class="w-full rounded-xl border border-gray-300 px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#de5806]">
                    <option *ngFor="let n of [0,1,2,3,4,5,6]" [value]="n">{{ n }}</option>
                </select>
            </div>
            <div>
                <label class="mb-1.5 block text-sm text-gray-700">{{ 'developerDashboard.createUnit.bathrooms' |
                    translate }}</label>
                <select [(ngModel)]="bathrooms"
                    class="w-full rounded-xl border border-gray-300 px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#de5806]">
                    <option *ngFor="let n of [1,2,3,4,5]" [value]="n">{{ n }}</option>
                </select>
            </div>
            <div>
                <label class="mb-1.5 block text-sm text-gray-700">{{ 'developerDashboard.createUnit.floorNumber' |
                    translate }}</label>
                <input type="number" [(ngModel)]="floorNumber"
                    class="w-full rounded-xl border border-gray-300 px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#de5806]" />
            </div>
            <div>
                <label class="mb-1.5 block text-sm text-gray-700">{{ 'developerDashboard.createUnit.maxGuests' |
                    translate }}</label>
                <input type="number" min="1" [(ngModel)]="maxGuests"
                    class="w-full rounded-xl border border-gray-300 px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#de5806]" />
            </div>
            <div>
                <label class="mb-1.5 block text-sm text-gray-700">{{ 'developerDashboard.createUnit.furnished' |
                    translate }}</label>
                <div class="flex gap-2 pt-1">
                    <button type="button" (click)="furnished = true"
                        class="flex-1 rounded-xl border-2 py-2 text-sm transition"
                        [ngClass]="furnished ? 'border-[#de5806] bg-[#de5806]/10 text-[#470e03]' : 'border-gray-200 text-gray-500'">{{
                        'developerDashboard.common.yes' | translate }}</button>
                    <button type="button" (click)="furnished = false"
                        class="flex-1 rounded-xl border-2 py-2 text-sm transition"
                        [ngClass]="!furnished ? 'border-[#de5806] bg-[#de5806]/10 text-[#470e03]' : 'border-gray-200 text-gray-500'">{{
                        'developerDashboard.common.no' | translate }}</button>
                </div>
            </div>
        </div>

            <div class="rounded-xl border border-gray-200 p-4">
            <h3 class="mb-3 text-sm text-gray-700">{{ 'developerDashboard.createUnit.location' | translate }}</h3>
            <div class="grid grid-cols-1 gap-3 md:grid-cols-2">
                <div>
                    <label class="mb-1 block text-xs text-gray-500">{{ 'developerDashboard.createUnit.cityAr' |
                        translate }}</label>
                    <input type="text" dir="rtl" [(ngModel)]="city_ar"
                        class="w-full rounded-xl border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#de5806]" />
                </div>
                <div>
                    <label class="mb-1 block text-xs text-gray-500">{{ 'developerDashboard.createUnit.cityEn' |
                        translate }}</label>
                    <input type="text" [(ngModel)]="city_en"
                        class="w-full rounded-xl border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#de5806]" />
                </div>
                <div>
                    <label class="mb-1 block text-xs text-gray-500">{{ 'developerDashboard.createUnit.areaAr' |
                        translate }}</label>
                    <input type="text" dir="rtl" [(ngModel)]="area_ar"
                        class="w-full rounded-xl border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#de5806]" />
                </div>
                <div>
                    <label class="mb-1 block text-xs text-gray-500">{{ 'developerDashboard.createUnit.areaEn' |
                        translate }}</label>
                    <input type="text" [(ngModel)]="area_en"
                        class="w-full rounded-xl border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#de5806]" />
                </div>
                <div>
                    <label class="mb-1 block text-xs text-gray-500">{{ 'developerDashboard.createUnit.addressAr' |
                        translate }}</label>
                    <input type="text" dir="rtl" [(ngModel)]="address_ar"
                        class="w-full rounded-xl border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#de5806]" />
                </div>
                <div>
                    <label class="mb-1 block text-xs text-gray-500">{{ 'developerDashboard.createUnit.addressEn' |
                        translate }}</label>
                    <input type="text" [(ngModel)]="address_en"
                        class="w-full rounded-xl border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#de5806]" />
                </div>
                <div>
                    <label class="mb-1 block text-xs text-gray-500">{{ 'developerDashboard.createUnit.lng' | translate
                        }}</label>
                    <input type="number" [(ngModel)]="lng"
                        class="w-full rounded-xl border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#de5806]" />
                </div>
                <div>
                    <label class="mb-1 block text-xs text-gray-500">{{ 'developerDashboard.createUnit.lat' | translate
                        }}</label>
                    <input type="number" [(ngModel)]="lat"
                        class="w-full rounded-xl border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#de5806]" />
                </div>
            </div>
        </div>

             <div>
            <h3 class="mb-3 text-sm text-gray-700">{{ 'developerDashboard.createUnit.facilities' | translate }}</h3>
            <div class="grid grid-cols-2 gap-2 sm:grid-cols-4">
                <button *ngFor="let f of availableFacilities" type="button" (click)="toggleFacility(f.key_en, f.key_ar)"
                    class="rounded-xl border-2 px-3 py-2.5 text-sm transition"
                    [ngClass]="isFacilitySelected(f.key_en) ? 'border-[#de5806] bg-[#de5806]/10 text-[#470e03]' : 'border-gray-200 text-gray-600 hover:border-gray-300'">
                    {{ f.key_ar }}
                </button>
            </div>
        </div>

             <div>
            <h3 class="mb-3 text-sm text-gray-700">{{ 'developerDashboard.createUnit.utilities' | translate }}</h3>
            <div class="space-y-2">
                <div *ngFor="let util of utilities_ar; let i = index" class="flex gap-2">
                    <input [ngModel]="utilities_ar[i]" (ngModelChange)="updateUtility('ar', i, $event)" type="text"
                        class="flex-1 rounded-xl border border-gray-300 px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#de5806]"
                        placeholder="مثال: كهرباء" />
                    <input [ngModel]="utilities_en[i]" (ngModelChange)="updateUtility('en', i, $event)" type="text"
                        class="flex-1 rounded-xl border border-gray-300 px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#de5806]"
                        placeholder="e.g., electricity" />
                    <button type="button" (click)="removeUtility(i)"
                        class="rounded-xl border border-red-500 px-3 text-red-500 hover:bg-red-50">
                        <i class="fas fa-trash text-xs"></i>
                    </button>
                </div>
                <button type="button" (click)="addUtility()"
                    class="w-full rounded-xl border border-dashed border-gray-300 px-3 py-2.5 text-sm text-gray-600 hover:border-[#de5806] hover:text-[#de5806]">
                    <i class="fas fa-plus me-1"></i>{{ 'developerDashboard.createUnit.addUtility' | translate }}
                </button>
            </div>
        </div>

             <div>
            <label class="mb-1.5 block text-sm text-gray-700">{{ 'developerDashboard.createUnit.status' | translate
                }}</label>
            <select [(ngModel)]="status"
                class="w-full rounded-xl border border-gray-300 px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#de5806]">
                <option value="active">{{ 'developerDashboard.createUnit.statusActive' | translate }}</option>
                <option value="inactive">{{ 'developerDashboard.createUnit.statusInactive' | translate }}</option>
                <option value="draft">{{ 'developerDashboard.createUnit.statusDraft' | translate }}</option>
                <option value="pending">{{ 'developerDashboard.createUnit.statusPending' | translate }}</option>
                <option value="reserved">{{ 'developerDashboard.createUnit.statusReserved' | translate }}</option>
                <option value="sold">{{ 'developerDashboard.createUnit.statusSold' | translate }}</option>
                <option value="rented">{{ 'developerDashboard.createUnit.statusRented' | translate }}</option>
                <option value="rejected">{{ 'developerDashboard.createUnit.statusRejected' | translate }}</option>
            </select>
        </div>

        <div class="flex justify-end">
            <button type="button" (click)="setStep('price')"
                class="gradient-primary-btn rounded-xl px-6 py-2.5 text-sm text-white transition hover:opacity-90">
                {{ 'developerDashboard.createUnit.nextPrice' | translate }} <i
                    class="fas fa-arrow-left ms-2 text-xs"></i>
            </button>
        </div>
    </div>

        <div *ngIf="step === 'price'" class="space-y-5">

            <div *ngIf="showRent" class="rounded-xl border border-gray-200 p-4 space-y-4">
            <h3 class="text-sm text-gray-800">{{ 'developerDashboard.createUnit.rentPricing' | translate }}</h3>
            <div class="grid grid-cols-1 gap-3 sm:grid-cols-3">
                <div>
                    <label class="mb-1.5 block text-sm text-gray-700">{{ 'developerDashboard.createUnit.basePrice' |
                        translate }}</label>
                    <input type="number" min="0" [(ngModel)]="rentPrice"
                        class="w-full rounded-xl border border-gray-300 px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#de5806]" />
                </div>
                <div>
                    <label class="mb-1.5 block text-sm text-gray-700">{{ 'developerDashboard.createUnit.securityDeposit'
                        | translate }}</label>
                    <input type="number" min="0" [(ngModel)]="securityDeposit"
                        class="w-full rounded-xl border border-gray-300 px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#de5806]" />
                </div>
                <div>
                    <label class="mb-1.5 block text-sm text-gray-700">{{ 'developerDashboard.createUnit.currency' |
                        translate }}</label>
                    <select [(ngModel)]="rentCurrency"
                        class="w-full rounded-xl border border-gray-300 px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#de5806]">
                        <option>EGP</option>
                        <option>USD</option>
                        <option>SAR</option>
                    </select>
                </div>
            </div>
                 <div>
                <div class="mb-2 flex items-center justify-between">
                    <span class="text-sm text-gray-700">{{ 'developerDashboard.createUnit.priceTiers' | translate
                        }}</span>
                    <button type="button" (click)="addTier()" class="text-xs text-[#de5806] hover:underline">{{
                        'developerDashboard.createUnit.addTier' | translate }}</button>
                </div>
                <div *ngFor="let tier of rentTiers; let i = index" class="mb-2 grid grid-cols-3 gap-2 items-end">
                    <div>
                        <label class="mb-1 block text-xs text-gray-500">{{ 'developerDashboard.createUnit.minDays' |
                            translate }}</label>
                        <input type="number" min="1" [(ngModel)]="tier.minDays"
                            class="w-full rounded-xl border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#de5806]" />
                    </div>
                    <div>
                        <label class="mb-1 block text-xs text-gray-500">{{ 'developerDashboard.createUnit.pricePerDay' |
                            translate }}</label>
                        <input type="number" min="0" [(ngModel)]="tier.pricePerDay"
                            class="w-full rounded-xl border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#de5806]" />
                    </div>
                    <div class="flex gap-2">
                        <div class="flex-1">
                            <label class="mb-1 block text-xs text-gray-500">{{ 'developerDashboard.createUnit.tierLabel'
                                | translate }}</label>
                            <input type="text" [(ngModel)]="tier.label"
                                class="w-full rounded-xl border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#de5806]" />
                        </div>
                        <button type="button" (click)="removeTier(i)" class="pb-1 text-red-400 hover:text-red-600">
                            <i class="fas fa-trash text-sm"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>

            <div *ngIf="showSale" class="rounded-xl border border-gray-200 p-4 space-y-4">
            <h3 class="text-sm text-gray-800">{{ 'developerDashboard.createUnit.salePricing' | translate }}</h3>
            <div class="grid grid-cols-1 gap-3 sm:grid-cols-3">
                <div>
                    <label class="mb-1.5 block text-sm text-gray-700">{{ 'developerDashboard.createUnit.basePrice' |
                        translate }}</label>
                    <input type="number" min="0" [(ngModel)]="basePrice"
                        class="w-full rounded-xl border border-gray-300 px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#de5806]" />
                </div>
                <div>
                    <label class="mb-1.5 block text-sm text-gray-700">{{ 'developerDashboard.createUnit.pricePerMeter' |
                        translate }}</label>
                    <input type="number" min="0" [(ngModel)]="pricePerMeter"
                        class="w-full rounded-xl border border-gray-300 px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#de5806]" />
                </div>
                <div>
                    <label class="mb-1.5 block text-sm text-gray-700">{{ 'developerDashboard.createUnit.currency' |
                        translate }}</label>
                    <select [(ngModel)]="saleCurrency"
                        class="w-full rounded-xl border border-gray-300 px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#de5806]">
                        <option>EGP</option>
                        <option>USD</option>
                        <option>SAR</option>
                        <option>AED</option>
                    </select>
                </div>
            </div>
            <div class="flex items-center gap-3">
                <span class="text-sm text-gray-700">{{ 'developerDashboard.createUnit.negotiable' | translate }}</span>
                <button type="button" (click)="negotiable = !negotiable"
                    class="rounded-xl border-2 px-4 py-1.5 text-sm transition"
                    [ngClass]="negotiable ? 'border-[#de5806] bg-[#de5806]/10 text-[#470e03]' : 'border-gray-200 text-gray-500'">
                    {{ negotiable ? ('developerDashboard.common.yes' | translate) : ('developerDashboard.common.no' |
                    translate) }}
                </button>
            </div>
                 <div>
                <div class="mb-2 flex items-center justify-between">
                    <span class="text-sm text-gray-700">{{ 'developerDashboard.createUnit.paymentPlans' | translate
                        }}</span>
                    <button type="button" (click)="addPlan()" class="text-xs text-[#de5806] hover:underline">{{
                        'developerDashboard.createUnit.addPlan' | translate }}</button>
                </div>
                <div *ngFor="let plan of salePlans; let i = index"
                    class="mb-3 rounded-xl border border-gray-100 p-3 space-y-2">
                    <div class="flex items-center justify-between">
                        <span class="text-xs text-gray-500">{{ 'developerDashboard.createUnit.plan' | translate }} {{ i
                            + 1 }}</span>
                        <button type="button" (click)="removePlan(i)" class="text-xs text-red-400 hover:text-red-600">{{
                            'developerDashboard.createUnit.removePlan' | translate }}</button>
                    </div>
                    <div class="grid grid-cols-2 gap-2">
                        <div>
                            <label class="mb-1 block text-xs text-gray-500">{{
                                'developerDashboard.createUnit.planNameAr' | translate }}</label>
                            <input type="text" dir="rtl" [(ngModel)]="plan.name_ar"
                                class="w-full rounded-xl border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#de5806]" />
                        </div>
                        <div>
                            <label class="mb-1 block text-xs text-gray-500">{{
                                'developerDashboard.createUnit.planNameEn' | translate }}</label>
                            <input type="text" [(ngModel)]="plan.name_en"
                                class="w-full rounded-xl border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#de5806]" />
                        </div>
                        <div>
                            <label class="mb-1 block text-xs text-gray-500">{{ 'developerDashboard.createUnit.saleType'
                                | translate }}</label>
                            <select [(ngModel)]="plan.saleType"
                                class="w-full rounded-xl border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#de5806]">
                                <option value="cash">{{ 'developerDashboard.createUnit.saleTypeCash' | translate }}
                                </option>
                                <option value="installment">{{ 'developerDashboard.createUnit.saleTypeInstallment' |
                                    translate }}</option>
                            </select>
                        </div>
                        <div>
                            <label class="mb-1 block text-xs text-gray-500">{{ 'developerDashboard.createUnit.years' |
                                translate }}</label>
                            <input type="number" min="0" [(ngModel)]="plan.years"
                                class="w-full rounded-xl border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#de5806]" />
                        </div>
                        <div>
                            <label class="mb-1 block text-xs text-gray-500">{{
                                'developerDashboard.createUnit.downPayment' | translate }}</label>
                            <input type="number" min="0" max="100" [(ngModel)]="plan.downPaymentPercent"
                                class="w-full rounded-xl border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#de5806]" />
                        </div>
                        <div>
                            <label class="mb-1 block text-xs text-gray-500">{{ 'developerDashboard.createUnit.interest'
                                | translate }}</label>
                            <input type="number" min="0" [(ngModel)]="plan.interestRate"
                                class="w-full rounded-xl border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#de5806]" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex justify-between">
            <button type="button" (click)="setStep('common')"
                class="rounded-xl border border-gray-200 px-5 py-2.5 text-sm text-gray-600 transition hover:bg-gray-50">
                <i class="fas fa-arrow-right me-2 text-xs"></i>{{ 'developerDashboard.createUnit.previousStep' |
                translate }}
            </button>
            <button type="button" (click)="setStep('media')"
                class="gradient-primary-btn rounded-xl px-6 py-2.5 text-sm text-white transition hover:opacity-90">
                {{ 'developerDashboard.createUnit.nextMedia' | translate }} <i
                    class="fas fa-arrow-left ms-2 text-xs"></i>
            </button>
        </div>
    </div>

        <div *ngIf="step === 'media'" class="space-y-5">

            <div class="rounded-xl border border-gray-200 p-4">
            <h3 class="mb-3 text-sm text-gray-700">{{ 'developerDashboard.createUnit.gallery' | translate }}</h3>
            <input type="file" multiple accept="image/*" (change)="onGalleryChange($event)"
                class="w-full rounded-xl border border-gray-300 px-4 py-2.5 text-sm" />
            <div *ngIf="galleryPreviews.length > 0" class="mt-3 grid grid-cols-3 gap-2 sm:grid-cols-4">
                <div *ngFor="let src of galleryPreviews" class="overflow-hidden rounded-xl">
                    <img [src]="src" class="h-24 w-full object-cover" />
                </div>
            </div>
        </div>

            <div class="rounded-xl border border-gray-200 p-4">
            <h3 class="mb-3 text-sm text-gray-700">{{ 'developerDashboard.createUnit.documents' | translate }}</h3>
            <input type="file" multiple (change)="onDocumentsChange($event)"
                class="w-full rounded-xl border border-gray-300 px-4 py-2.5 text-sm" />
            <p *ngIf="documentFiles.length > 0" class="mt-2 text-xs text-gray-500">
                {{ documentFiles.length }} {{ 'developerDashboard.createUnit.filesSelected' | translate }}
            </p>
        </div>

        <div class="flex justify-between">
            <button type="button" (click)="setStep('price')"
                class="rounded-xl border border-gray-200 px-5 py-2.5 text-sm text-gray-600 transition hover:bg-gray-50">
                <i class="fas fa-arrow-right me-2 text-xs"></i>{{ 'developerDashboard.createUnit.previousStep' |
                translate }}
            </button>
            <button type="button" (click)="submit()" [disabled]="isSaving"
                class="gradient-primary-btn rounded-xl px-6 py-2.5 text-sm text-white transition hover:opacity-90 disabled:opacity-50">
                <i *ngIf="isSaving" class="fas fa-spinner fa-spin me-2 text-xs"></i>
                {{ isSaving ? ('developerDashboard.createUnit.creating' | translate) :
                ('developerDashboard.createUnit.createUnit' | translate) }}
            </button>
        </div>
    </div>
</div> -->
<app-add-new-property></app-add-new-property>